module.exports = require("/usr/src/app/www/src/redux/createStore")